import { render, staticRenderFns } from "./CategoryAccordion.vue?vue&type=template&id=0879ea06&"
import script from "./CategoryAccordion.vue?vue&type=script&lang=ts&"
export * from "./CategoryAccordion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports